// extracted by mini-css-extract-plugin
module.exports = {"card":"da51a739f7--card--Z1xsH"};